/**
 * Utility functions for generating client-based routes
 */

/**
 * Gets the conversations route for a given client
 * @param client - The client identifier
 * @param threadId - Optional thread ID
 * @returns The conversations route for the client
 */
export function getClientConversationsRoute(
  client: string,
  threadId?: string,
): string {
  const baseRoute = `/${client}`;
  if (threadId) {
    return `${baseRoute}/conversations/${threadId}`;
  }
  return baseRoute;
}

/**
 * Detects the current client from the URL path
 * @param pathname - Current pathname (window.location.pathname)
 * @returns The detected client identifier
 */
export function detectClientFromPath(pathname: string): string {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length > 0) {
    return segments[0];
  }
  return "ai"; // fallback to default
}
